import { defineMessages } from 'react-intl';

export const qrCodeDialogMessages = defineMessages({
    downloadAppCopy: {
        id: 'qrCodeDialog.downloadApp',
        defaultMessage: 'Unlock the full potential of Calm Health!',
        description:
            'Message prompting the user to download the Calm Health app from the their device app store.',
    },
});
